export default "__VITE_ASSET__Sekm$FaG__"